import { render, staticRenderFns } from "./TeacherTableActions.vue?vue&type=template&id=1a823f40"
import script from "./TeacherTableActions.vue?vue&type=script&lang=js"
export * from "./TeacherTableActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports